export enum MatchType {
  IncludeAll = 1,
  IncludeAny = 2,
  ExcludeAll = 3,
  ExcludeAny = 4
}
